export default {
      id: "icon-chart-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-chart",
      toString: function () {
        return this.url;
      }
    }